module.exports = __webpack_public_path__ + "src/img/smalldown.6b8b2c3b.svg";